export const readUddsCaptureContext = (location, document) => {
    const query = new URLSearchParams(location.search)
    const root = document.getElementById('reservation_container')

    const hasRecoveryMarker = Boolean(
        root && root.getAttribute('data-checkout-recovery'),
    )

    if (
        query.has('checkout_recovery') ||
        document.getElementById('checkout_recovery_data') ||
        hasRecoveryMarker ||
        /\/reservation\/checkout-recovery(?:\/|$)/.test(location.pathname)
    ) {
        return null
    }

    const offerHash = location.pathname.split('/').filter(Boolean).pop()

    if (!offerHash) {
        return null
    }

    let decodedHash

    try {
        decodedHash = decodeURIComponent(offerHash)
    } catch (error) {
        return null
    }

    if (decodedHash.includes('|TUI') || decodedHash.includes('|R')) {
        return null
    }

    const operator = query.get('operator')
    const snapshotUuid = query.get('udds_snapshot')
    const departureDate = query.get('od')
    const adults = Number(query.get('dorosli'))
    const rawLength = query.get('length')
    const length = rawLength ? Number(rawLength) : null

    if (
        !operator ||
        !snapshotUuid ||
        !departureDate ||
        !Number.isInteger(adults) ||
        adults < 1 ||
        (length !== null && (!Number.isInteger(length) || length < 1))
    ) {
        return null
    }

    const children = String(query.get('dzieci') || '')
        .split(',')
        .map((age) => age.trim())
        .filter((age) => age !== '')

    if (children.some((age) => !/^\d{1,2}$/.test(age))) {
        return null
    }

    return {
        offerHash,
        operator,
        extType: query.get('extType') || query.get('offerType') || 'MDS',
        od: departureDate,
        do: query.get('do') || null,
        length,
        dorosli: adults,
        dzieci: children.length > 0 ? children.join(',') : null,
        udds_snapshot: snapshotUuid,
    }
}
